import store from 'store';
import { message } from 'antd';
import { vendorBusinessInfoCheck } from '../services/api';
import { saveFinishedStep } from '../views/Register/Basic';

function init() {
  const operationInfoData = store.get('operationInfoData') || {};
  operationInfoData.managerSystemAttachments = operationInfoData.managerSystemAttachments || [];
  return {
    operationInfoData
  };
}

export default {
  namespace: 'operationInfoRegister',

  state: init(),
  effects: {
    *checkOperationInfo({ payload }, { call }) {
      const { props, data } = payload;
      const operationInfoData = { ...data.operationInfoData };
      operationInfoData.totalSales = JSON.stringify(operationInfoData.totalSales);
      const res = yield call(vendorBusinessInfoCheck, operationInfoData);
      if (res.success) {
        saveFinishedStep(5);
        props.history.push('/register/basic/step-six');
      } else {
        res.msg && message.error(res.msg);
      }
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    updateInfoData(state, { payload: { data } }) {
      return {
        ...state,
        operationInfoData: {
          ...state.operationInfoData,
          ...data
        }
      };
    },
    clear() {
      return init();
    }
  }
};
